<template>
  <div id="q-app">
    <!-- style="background-color:#edffea"-->
    <transition-group
      appear
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div key="div2" v-if="fullLoading" class="loaderOverlay">
        <div key="div2" class="lds-ripple">
          <div key="div3"></div>
          <div key="div4"></div>
        </div>
      </div>
    </transition-group>

    <q-layout view="lHh lpR fFf">
      <app-bar v-if="!$route.meta.fullscreen" />
      <q-page-container v-if="!fullLoading" class="bg-secondary">
        <router-view
          :class="{
            'q-pa-sm': !$route.meta.fullscreen && this.$q.screen.lt.sm,
            'q-pa-md': !$route.meta.fullscreen && this.$q.screen.gt.sm,
          }"
        />
      </q-page-container>
    </q-layout>
  </div>
</template>

<script>
  import { auth } from "@/firebase.js";
  import { mapGetters } from "vuex";
  import AppBar from "@/components/AppBar";

  export default {
    components: {
      AppBar,
    },
    computed: {
      ...mapGetters({
        fullLoading: "settings/fullLoading",
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        offlineMode: "offlineMode",
      }),
    },
    data: () => ({}),
    watch: {
      currentUser: function (oldData, newData) {
        this.checkLoggedIn();
      },
      $route: function (newRoute, oldRoute) {
        this.checkLoggedIn();
      },
      currentUserData: function () {
        if (
          this.$router.path != "/wizard" &&
          this.currentUserData.hasOwnProperty("role") &&
          !this.currentUserData.role.includes("Admin")
        ) {
        }
      },
    },
    mounted() {
      this.checkLoggedIn();
    },
    methods: {
      checkLoggedIn() {
        // var ts = Math.round(new Date().getTime() / 1000);
        if (this.currentUser != null && this.currentUser != "loading") {
          if (this.$route.path === "/login") {
            this.$router.push("/");
          }
        } else if (this.currentUser != "loading") {
          if (this.$route.path != "/login") {
            this.$router.push("/login");
          }
        }
      },
    },
  };
</script>

<style lang="scss">
  ::-webkit-scrollbar {
    width: 5px;
    height: 10px;
  }
  ::-webkit-scrollbar-track {
    background: $scrollbarTrack;
  }
  ::-webkit-scrollbar-thumb {
    background: $scrollbarThumb;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: $scrollbarHover;
  }
  .loaderOverlay {
    z-index: 9999;
    background: $accent;
    width: 100vw;
    height: 100vh;
    position: fixed;
  }
  .lds-ripple {
    top: calc(50vh - 40px);
    left: calc(50vw - 40px);
    display: inline-block;
    position: fixed;
    width: 80px;
    height: 80px;
  }
  .lds-ripple div {
    position: absolute;
    border: 4px solid $primary;
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  .lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
  }
  @keyframes lds-ripple {
    0% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: 0px;
      left: 0px;
      width: 72px;
      height: 72px;
      opacity: 0;
    }
  }
  .swal2-container {
    z-index: 10060 !important;
  }

  .vc-container {
    border: 0px !important;
  }

  .on-right {
    margin-left: 0px !important;
  }

  .on-left {
    margin-right: 0px !important;
  }
</style>
